module.exports = __webpack_public_path__ + "static/img/daohui_guantang_img1.3768830.png";